export default "__VITE_ASSET__CMtmJvgy__"